import { Fragment, useState, useEffect } from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";

// Importamos la constante configurada para PHP
import { API_URL } from '../Parametrizaciones.js';

function Masterinc() {
  const navigate = useNavigate();

  // --- ESTADOS ---
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [listUpdate, setListUpdate] = useState(false);

  // --- 1. VERIFICACIÓN DE SESIÓN AL ENTRAR ---
  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      setIsAuthenticated(true); // Si ya tiene token, mostramos el panel directo
    } else {
      setIsAuthenticated(false); // Si no, forzamos a mostrar el modal
      // Forzamos visualmente la apertura del modal de Bootstrap si no está logueado
      const modalElement = document.getElementById("loginModal");
      if (modalElement && window.$) {
        window.$(modalElement).modal({
          backdrop: 'static', // Evita que se cierre al hacer clic afuera
          keyboard: false     // Evita que se cierre con la tecla ESC
        });
        window.$(modalElement).modal('show');
      }
    }
  }, []);

  // --- 2. PETICIÓN DE LOGIN AL SERVIDOR PHP ---
  const gotoAdministrative = async (e) => {
    if (e) e.preventDefault();

    if (!username.trim() || !password.trim()) {
      alert("Por favor ingresa usuario y contraseña.");
      return;
    }

    try {
      const response = await fetch(`${API_URL}?action=loginAdmin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username, password: password })
      });

      const data = await response.json();

      if (data.auth === true || data.status === "success") {
        // Guardamos el token devuelto (o el identificador de sesión)
        localStorage.setItem("admin_token", data.token || "authenticated_session");
        setIsAuthenticated(true);

        // Ocultamos el modal de Bootstrap tras loguearse con éxito
        const modalElement = document.getElementById("loginModal");
        if (modalElement && window.$) {
          window.$(modalElement).modal('hide');
        }
      } else {
        alert(data.message || "Credenciales incorrectas. Intenta de nuevo.");
      }
    } catch (err) {
      console.error("Error al conectar con la API PHP:", err);
      alert("Error de conexión con el servidor de autenticación.");
    }
  };

  // --- 3. EFECTO CARGA DE DATOS (Solo si está autenticado) ---
  useEffect(() => {
    if (!isAuthenticated) return;

    Modal.setAppElement("body");

    fetch(`${API_URL}?action=obtenerImagenesTop`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Datos del panel cargados:", data);
      })
      .catch((err) => {
        console.error("Error al cargar datos del panel:", err);
      });

    setListUpdate(false);
  }, [listUpdate, isAuthenticated]);

  // --- 4. FUNCIONES DE NAVEGACIÓN ---
  const clickToAdminPropiedad = () => navigate("/controllers/AdminPropiedad");
  const clickToAdminTop = () => navigate("/controllers/AdminTop");
  const clickToAdminPagos = () => navigate("/controllers/AdminTopImages");

  // Cerrar sesión
  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    setIsAuthenticated(false);
    window.location.reload(); // Recargamos para limpiar estados e invocar el modal
  };

  return (
    <Fragment>
      {/* ========================================================
        MODAL DE INICIO DE SESIÓN (BOOTSTRAP)
        ========================================================
      */}
      <div
        className="modal fade"
        id="loginModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="loginModalLabel"
        aria-hidden="true"
        data-backdrop="static" // Evita el cierre accidental
        data-keyboard="false"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="loginModalLabel">
                Uso Autorizado | Módulo Administrador
              </h4>
            </div>
            <form onSubmit={gotoAdministrative}>
              <div className="modal-body">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
                <br />
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <br />
                <button type="submit" className="btn btn-danger w-100">
                  Iniciar Sesión
                </button>
              </div>
              <div className="modal-footer">
                <a href="/" className="btn btn-secondary w-100">
                  Volver al Inicio (Salir)
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* ========================================================
        CONTENIDO ADMINISTRATIVO (Solo se ve si está autenticado)
        ========================================================
      */}
      {isAuthenticated && (
        <div className="aa-title">
          <div class="container">
            <br />
            <a href="/">
              <svg
                width="50"
                height="50"
                fill="currentColor"
                class="bi bi-house-fill"
                viewBox="0 0 16 16"
                style={{ color: "#59abe3" }}
              >
                <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293z" />
                <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293z" />
              </svg>
            </a>
            <h2>Administrador</h2>
            <span></span>
          </div>

          <br />

          <div className="container">
            <div className="form-group col-md-4" style={{ height: "100%", width: "100%" }}>
              <div className="aa-service-content">
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <button
                      style={{ width: '200px', height: '100px' }}
                      type="button"
                      className="btn btn-primary btn-lg"
                      onClick={clickToAdminPropiedad}
                    >
                      Administrar <br /> Propiedad
                    </button>
                  </div>
                  <div className="col-md-4 mb-3">
                    <button
                      type="button"
                      style={{ width: '200px', height: '100px' }}
                      className="btn btn-primary btn-lg"
                      onClick={clickToAdminTop}
                    >
                      Administrar <br /> Imagenes Top 6
                    </button>
                  </div>
                  <div className="col-md-4 mb-3">
                    <button
                      type="button"
                      style={{ width: '200px', height: '100px', color: "black", backgroundColor: "orange" }}
                      className="btn btn-primary btn-lg"
                    //disabled
                    //onClick={clickToAdminPagos}
                    >
                      Administrar <br /> Consulta de Pagos <br /> (Próximamente)
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container d-flex justify-content-between align-items-center">
            <button onClick={handleLogout} className="btn btn-primary btn-lg" style={{ width: '250px', height: '50px', color: "red", backgroundColor: "black" }}>
              Cerrar Sesión
            </button>
          </div>

        </div>
      )}
    </Fragment>
  );
}

export default Masterinc;